package com.hyperether.goodjob.scenes.scheduler.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.no_information
import com.hyperether.goodjob.resources.site
import com.hyperether.goodjob.scenes.components.CircleWithInitial
import com.hyperether.goodjob.util.StatusColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource

@Composable
fun SchedulerMonthJobCard(
    status: String,
    range: String,
    title: String,
    site: String,
    employee: String,
    onClick: () -> Unit
) {
    Box(
        modifier = Modifier.fillMaxWidth()
            .clickable {
                onClick()
            }
            .padding(vertical = 10.toScaleDp(), horizontal = 20.toScaleDp())
    ) {

        Row(
            modifier = Modifier.fillMaxWidth()
                .background(Color.White, shape = RoundedCornerShape(12.toScaleDp()))
                .border(
                    1.toScaleDp(),
                    Color.Gray,
                    shape = RoundedCornerShape(12.toScaleDp())
                )
                .padding(12.toScaleDp()),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {

            Column(modifier = Modifier.weight(1f)) {
                Row {
                    Column(
                        modifier = Modifier.weight(1f)
                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically
                        ) {

                            Box(
                                modifier = Modifier
                                    .size(16.toScaleDp())
                                    .background(
                                        color = StatusColor.getStatusColor(status),
                                        shape = CircleShape
                                    )
                            )
                            Spacer(modifier = Modifier.width(8.toScaleDp()))
                            Text(
                                text = range,
                                fontSize = 14.toScaleSp(),
                                color = Color.Gray,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }

                        Text(
                            text = title,
                            color = Color.Black,
                            fontWeight = FontWeight.Bold,
                            fontSize = 18.toScaleSp(),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Text(
                            text = stringResource(Res.string.site) + ": " + site.ifBlank {
                                stringResource(
                                    Res.string.no_information
                                )
                            },
                            fontSize = 14.toScaleSp(),
                            color = Color.Gray,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                }
            }

            CircleWithInitial(employee, size = 40.toScaleDp())
        }
    }
}